import ContactForm from "../../components/ContactForm";
import Section from "../../components/Section";
import SectionLayout from "../../components/[przyjaznedeklaracje]/_sectionLayout";
import DeclarationBox from "../../components/DeclarationBox";
import DeclarationBoxItem from "../../components/DeclarationBoxItem";
import DeclarationModal from "../../components/DeclarationModal";

import Variables from "../../variables/variables.json";
import BackButton from "../../components/BackButton";

import DeclarationBoxIndividual from "../../components/DeclarationBoxIndividual";
import BackgroundSection from "../../components/BackgroundSection";
import SectionBox from "../../components/SectionBox";
import CustomListWithZero from "../../components/CustomListWithZero";
import FAQ from "../../components/FAQ";
import FloatVideo from "../../components/FloatVideo";

import NieruchomosciPL1 from "../../content/przyjaznedeklaracje/podatek-od-nieruchomosci/section-1_pl.mdx";
import NieruchomosciPL2 from "../../content/przyjaznedeklaracje/podatek-od-nieruchomosci/section-2_pl.mdx";
import NieruchomosciPL3 from "../../content/przyjaznedeklaracje/podatek-od-nieruchomosci/section-3_pl.mdx";
import NieruchomosciPL4 from "../../content/przyjaznedeklaracje/podatek-od-nieruchomosci/section-4_pl.mdx";
import NieruchomosciPL5 from "../../content/przyjaznedeklaracje/podatek-od-nieruchomosci/section-5_pl.mdx";

export default function PodatekOdNieruchomosci(props) {
	let Miasto = "PRZYJAZNEDEKLARACJE";
	let Podatek = "nieruchomosci";

	return (
		<SectionLayout miasto={Miasto} podatek={Podatek} typeHero="slider" breadcrumbsLayout="light">
			<Section mdx>
				<NieruchomosciPL1 />
			</Section>

			<Section mdx lighterdark noPanel>
				<NieruchomosciPL2 />
			</Section>

			<Section mdx>
				<div className="declaration-box-individual__columns">
					<DeclarationBoxIndividual podatek="in1" btnPrimary button="link" />
					<DeclarationBoxIndividual podatek="dn1" btnPrimary button="link" />
				</div>

				<NieruchomosciPL3 />
			</Section>

			<BackgroundSection
				miasto="PRZYJAZNEDEKLARACJE"
				section="podatekodnieruchomosci"
				attachment
				textAlign="left"
				button="dialog"
				dialogShow="podatek-od-nieruchomosci"
				title
				subtitle
				bgColor="shadow"
			/>

			<Section mdx>
				<NieruchomosciPL4 />
			</Section>

			<Section lightdark title="sections.jakzlozycdeklaracjepodatkowa.title">
				<SectionBox light white round section="jakzlozycdeklaracjepodatkowa" />
			</Section>

			<BackgroundSection
				miasto="PRZYJAZNEDEKLARACJE"
				section="podatekodnieruchomosci"
				attachment
				textAlign="left"
				button="dialog"
				dialogShow="podatek-od-nieruchomosci"
				title
				subtitle
				bgColor="shadow"
			/>

			<Section mdx lighterdark>
				<NieruchomosciPL5 />

				<CustomListWithZero miasto={Miasto} section={Podatek} />
			</Section>

			<Section title="sections.czestozadawanepytania.title" id="czesto-zadawane-pytania-faq">
				<FAQ miasto={Miasto} section={Podatek} secondary />
			</Section>

			<Section id="wypelnij-deklaracje" title="sections.wypelnijdeklaracjeinformacje.title">
				<DeclarationBox center>
					<DeclarationBoxItem miasto={Miasto} podatek={Podatek} noReadMore />
				</DeclarationBox>
				<DeclarationModal miasto={Miasto} podatek={Podatek} />
			</Section>

			<Section>
				<BackButton />
			</Section>

			<FloatVideo config="in1" />
		</SectionLayout>
	);
}
